import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";

const Sessions = () => {
  return (
    <React.Fragment>
      <SEO title="Sessions | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Sessions"
        content="The Conference"
        contentTwo="Sessions"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content title-center">
          <h2>ICSI&apos;2026 Session Schedule</h2>
          <p>
            Detailed session timetables are being updated. Please check back
            later.
          </p>
        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Sessions;
